export const TYPOGRAPHY_CONFIG = {
  'trail-display1': [
    '4rem', // 64px
    {
      lineHeight: '4.313rem', // 69px
      letterSpacing: '-0.12rem', // -1.92px
      fontWeight: 500,
    },
  ],
  'trail-display2': [
    '2rem', // 32px
    {
      lineHeight: '2.313rem', // 37px
      letterSpacing: '-0.06rem', // -0,96px
      fontWeight: 500,
    },
  ],
  'trail-title1': [
    '1.375rem', // 22px
    {
      lineHeight: '2rem', // 32px
      letterSpacing: '-0.0275rem', // -0.44px
      fontWeight: 500,
    },
  ],
  'trail-title2': [
    '1.25rem', // 20px
    {
      lineHeight: '1.75rem', // 28px
      letterSpacing: '-0.025rem', // -0.4px
      fontWeight: 500,
    },
  ],
  'trail-title3': [
    '1.125rem', // 18px
    {
      lineHeight: '1.625rem', // 26px
      letterSpacing: '-0.0225rem', // -0.36px
      fontWeight: 500,
    },
  ],
  'trail-title4': [
    '1rem', // 16px
    {
      lineHeight: '1.5rem', // 24px
      letterSpacing: '-0.02rem', // -0.32px
      fontWeight: 500,
    },
  ],
  'trail-title5': [
    '0.875rem', // 14px
    {
      lineHeight: '1.375rem', // 22px
      letterSpacing: '-0.0175rem', // -0.28px
      fontWeight: 500,
    },
  ],
  'trail-body1': [
    '1.125rem', // 18px
    {
      lineHeight: '1.75rem', // 28px
      letterSpacing: '-0.01125rem', // -0.18px
      fontWeight: 400,
    },
  ],
  'trail-body2': [
    '1rem', // 16px
    {
      lineHeight: '1.625rem', // 26px
      letterSpacing: '-0.01rem', // -0.16px
      fontWeight: 400,
    },
  ],
  'trail-body3': [
    '0.875rem', // 14px
    {
      lineHeight: '1.5rem', // 24px
      letterSpacing: '-0.00875rem', // -0.14px
      fontWeight: 400,
    },
  ],
  'trail-body-link1': [
    '1.125rem', // 18px
    {
      lineHeight: '1.75rem', // 28px
      fontWeight: 400,
      letterSpacing: '-0.01125rem', // -0.18px
      textDecoration: 'underline',
    },
  ],
  'trail-body-link2': [
    '1rem', // 16px
    {
      lineHeight: '1.625rem', // 26px
      fontWeight: 400,
      letterSpacing: '-0.01rem', // -0.16px
      textDecoration: 'underline',
    },
  ],
  'trail-body-link3': [
    '0.875rem', // 14px
    {
      lineHeight: '1.5rem', // 24px
      fontWeight: 400,
      letterSpacing: '-0.00875rem', // -0.14px
      textDecoration: 'underline',
    },
  ],
  'trail-caption': [
    '0.75rem', // 12px
    {
      lineHeight: '1.375rem', // 22px
      fontWeight: 400,
    },
  ],
}
